import styled, { css } from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { rawColors } from "../../../design-system/tokens/colors";
import { duration, easing } from "../../../design-system/tokens/transitions";

export const TabButton = styled.button<{ $isActive: boolean }>`
  /* Reset native button */
  appearance: none;
  &[aria-disabled="true"] { cursor: not-allowed; }
  background: none;
  margin: 0;
  cursor: pointer;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing[2]} ${spacing[3]};
  border: none;
  border-bottom: 2px solid transparent;
  /* Inactive tabs: medium-emphasis (was low-emphasis — too faint at 12px caption) */
  ${typographyMixin("body", 4)}
  color: ${({ theme }) => theme.colors?.text?.tertiary ?? rawColors.text.lowEmphasis};
  gap: ${spacing[1.5]};
  white-space: nowrap;
  transition: color ${duration.fast} ${easing.smooth}, border-color ${duration.fast} ${easing.smooth};

  // &:hover:not(:disabled) {
  //   color: ${rawColors.text.highEmphasis};
  // }

  &:focus-visible {
    outline: 2px solid ${rawColors.primary[500]};
    outline-offset: 2px;
    border-radius: 2px;
  }

  ${({ $isActive, theme }) =>
    $isActive &&
    css`
      ${typographyMixin("body", 3)}
      color: ${theme.colors?.text?.interactive ?? rawColors.primary[500]};
      border-bottom-color: ${theme.colors?.text?.interactive ?? rawColors.primary[500]};

      &:hover:not(:disabled) {
        color: ${theme.colors?.text?.interactive ?? rawColors.primary[500]};
      }
    `}
`;
